(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/helpers/deposit-helpers.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/helpers/deposit-helpers.js');

'use strict';

const payAfterDeposit = () => {
  const payAfterDeposit = svs.utils.paramHandler.get({
    key: 'afterpay'
  }).value;
  svs.utils.paramHandler.remove({
    key: 'afterpay'
  });
  return payAfterDeposit;
};
svs.arena.helpers.depositHelpers = {
  payAfterDeposit
};

 })(window);